import qs from 'qs'
import { IDeviceInfo } from '../types/device'

export const getKioskDeviceId = (search: string): string => {
  const query = qs.parse(search, {
    ignoreQueryPrefix: true,
  })

  if (query?.deviceId) {
    return query?.deviceId as string
  }

  const deviceId = localStorage.getItem('deviceId')

  return deviceId
}

export const setHotelDevice = (device: IDeviceInfo) => {
  localStorage.setItem('deviceId', device.deviceId)
  localStorage.setItem('deviceName', device.deviceName)
}
